
import vClickOutside from 'v-click-outside';
export default {
  name: "QdapHomeQuestionnaireDropdown",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    selectedValue: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      selectActive: false,
      selectedOptionValue: '',
    }
  },
  computed: {
    getDisplayText() {
      if ( this.data && this.selectedOptionValue ) {
        return this.selectedOptionValue.text;
      } else if ( this.selectedValue ) {
        const selected = this.data?.answer.find(item => item.value === this.selectedValue);
        return selected.text;
      } else {
        return this.data?.placeholder;
      }
    },
    getActiveOption() {
      return ( this.selectedValue ) ? this.selectedValue : 0;
    },
    getRelation() {
      return this.data?.relation;
    }
  },
  watch: {
    data(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedOptionValue = '';
      }
    }
  },
  methods: {
    inactiveDropdown() {
      this.selectActive = false;
    },
    selectItem(selected) {
      // console.debug('dropdown selected value -', selected.text);
      this.selectedOptionValue = { text: selected.text, value: selected.value};
      this.selectActive = false;
      this.$emit('update-selected', { text: selected.text, value: selected.value });
    },
    checkValidOption(item) {
      // if this.getRelation.reset = true, the current question value should be reset already
      if (!this.getRelation || this.getRelation.reset || this.getRelation.compare === undefined ) return;
      const maxValue = ( this.getRelation.maxValue === undefined) ? 0 : this.getRelation.maxValue;
      if ( this.getRelation.compare === '>') return item.value < maxValue;
      if ( this.getRelation.compare === '<') return item.value > maxValue;
    }
  }
}
